<!-- Previous code for Login for reference -->

<div class="mainBody">
    <!-- <div *ngIf="showErrorMessage">
        <h1>Invalid username and password Please try again</h1>
      </div> -->
<div fxLayoutAlign="center center" fxFlexFill  >
    <mat-card fxFlex="60" style="margin-top: 20px;">
        <mat-toolbar class="Primarycolor" >Login here</mat-toolbar>
        <form class="loginform" fxLayoutAlign="stretch" fxLayout="column"
            #loginForm="ngForm" (ngSubmit)="OnSubmit(username.value,password.value)">
            <mat-form-field>
                <input matInput placeholder="UserName" #username ngModel name="username" required>
            </mat-form-field>

            <mat-form-field>
                <input matInput type="password" placeholder="Password" #password ngModel name="password" required>
            </mat-form-field>
            <button mat-raised-button type="submit" color="primary" [disabled]="loginForm.invalid || loading" [class.spinner]="loading" >Login</button>
            <!-- <button mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="save()">Save</button> -->
        </form>
    </mat-card>
</div>
    <div *ngIf="userErrorMessage" class="ErrorMessage" >
        <p><br><b>#error:pwavmauser</b><br><br>
            User profile currently not active<br>
            You are not authorized to access this resource because your profile is currently not active<br>
            Please contact your manager to request access<br><br>

            ABG Fleetpro Team</p>
    </div> 
</div>

<!-- <div class="login-container" >

    <div class="login-content">
      <mat-toolbar class="login-toolbar"  >Login Here</mat-toolbar>
      <mat-card fxLayoutAlign="stretch" >
        <form  #loginForm="ngForm" (ngSubmit)="OnSubmit(username.value,password.value)">
            <mat-form-field floatLabel="never">
                <mat-icon matPrefix>person_outline</mat-icon>
                <input type="text" matInput placeholder="Username" #username ngModel name="username" required>
            </mat-form-field>

                <mat-form-field floatLabel="never">
                <mat-icon matPrefix>lock_outline</mat-icon>
                <input matInput type="password" placeholder="Password" #password ngModel name="password" required>
            </mat-form-field>

          <button mat-raised-button type="submit" class="Primarycolor" [disabled]="loginForm.invalid">Login</button>
        </form>
      </mat-card>
    </div>
  </div> -->
